import React, {useMemo, useRef} from "react"
import moment from "moment"
import {useSortable} from "@dnd-kit/sortable"
import {CSS} from "@dnd-kit/utilities"
import "./TimelineEvent.css"


export default function TimelineEvent(params) {

    const {rescue, events, index, setEvent, incTime, removeEvent, insertEvent, values, openPickerIndex, setOpenPickerIndex} = params
    const event = events[index]
    const eventTime = useMemo(() => new Date(event.time), [event.time])
    const time = eventTime.getHours().toString().padStart(2, '0') + ':' + eventTime.getMinutes().toString().padStart(2, '0')


    const [diffStyle, diffText] = useMemo(() => {
        if (index === 0) return [null, null]        
        const diff = eventTime - new Date(events[index-1].time)
        const diffMins = Math.round(diff / 60000)
        const diffHours = Math.floor(diffMins / 60)
        const m = diffMins % 60
        const height = Math.min(Math.round(Math.pow(diff/1000, 0.65)), 600) + 60
        const diffText = diffHours > 0 ? diffHours + ' h ' + m + ' min' : m + ' min'
        return [{ minHeight: `${height}px` }, diffText]
    }, [eventTime, events, index])


    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: event.id})

    const sortableStyle = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
    }


    const wrapperRef = useRef(null)

    const handleRemove = () => {
        const wrapper = wrapperRef.current
        const height = wrapper.offsetHeight
        wrapper.querySelector('.one-event').animate([
            {opacity: 1, transform: 'translateX(0)'},
            {opacity: 0, transform: 'translateX(28px)'}
        ], {duration: 180, easing: 'ease-out', fill: 'forwards'})
        wrapper.animate([
            {height: height + 'px', overflow: 'hidden'},
            {height: '0px', overflow: 'hidden'}
        ], {delay: 80, duration: 220, easing: 'ease-in', fill: 'forwards'})
            .finished.then(() => removeEvent(index))
    }

    const showInsertPicker = openPickerIndex === index

    const onInsert = (text) => {
        insertEvent(index, text)
    }

    const onChangeText = (e) => {
        const text = e.target.value
        const newEvent = {...event}
        newEvent.event = text
        setEvent(index, newEvent)
    }
    
    const onChangeTime = (e) => {
        let time = new Date(event.time)
		if (isNaN(time)) time = new Date()
		// const originalTime = new Date(time.getTime())
		
		const hhmm = e.target.value
		const hmarray = hhmm.split(':')
		const h = parseInt(hmarray[0])
		const m = parseInt(hmarray[1])
		time.setHours(h, m)
              
        const newEvent = {...event}
        newEvent.time = moment(time).toISOString(true)
        setEvent(index, newEvent)
    }
    

    return <div className="timeline-event-wrapper" style={sortableStyle} ref={wrapperRef}>
        {diffStyle &&
            <div className="time-diff" style={diffStyle}>
                {diffText}
                {!rescue.isReadOnly && <div className="insert-area">
                    <button
                        className="btn btn-sm insert-btn"
                        onClick={() => setOpenPickerIndex(showInsertPicker ? null : index)}
                        title="Umetni događaj"
                    ><i className="fa-solid fa-plus"/></button>
                    {showInsertPicker && <div className="insert-picker">
                        {values?.events?.map(ev => <button
                            key={ev.id}
                            className="btn btn-sm btn-light"
                            onClick={() => onInsert(ev.name)}
                        >{ev.name}</button>)}
                    </div>}
                </div>}
            </div>
        }
        <div className="one-event" ref={setNodeRef}>
            <div className="event-header">
                {!rescue.isReadOnly && <span className="drag-handle" {...attributes} {...listeners}>
                    <i className="fas fa-grip-vertical"/>
                </span>}
                <input type="text" value={event.event} className="event" onChange={onChangeText} readOnly={rescue.isReadOnly}/>
                {!rescue.isReadOnly && <button className="btn btn-light btn-sm event-delete" onClick={handleRemove}>
                    <i className="fas fa-times"/>
                </button>}
            </div>
            <div className="time">
                {!rescue.isReadOnly && <div className="button-group">
                    <button className="btn btn-light btn-sm inc-dec" onClick={() => incTime(index, -1)}>-1 min</button>
                    <button className="btn btn-light btn-sm inc-dec" onClick={() => incTime(index, -10)}>-10 min</button>
                    <button className="btn btn-light btn-sm inc-dec" onClick={() => incTime(index, -60)}>-1 h</button>
                </div>}
                <input type="time" value={time} required onChange={onChangeTime} readOnly={rescue.isReadOnly}/>
                {!rescue.isReadOnly && <div className="button-group">
                    <button className="btn btn-light btn-sm inc-dec" onClick={() => incTime(index, 1)}>+1 min</button>
                    <button className="btn btn-light btn-sm inc-dec" onClick={() => incTime(index, 10)}>+10 min</button>
                    <button className="btn btn-light btn-sm inc-dec" onClick={() => incTime(index, 60)}>+1 h</button>
                </div>}
            </div>
        </div>
    </div>
}